import angular from 'angular';

module.exports = angular.module('common.directives.xhr-progress', [])
.directive('odXhrProgress', function($rootScope) {
  return {
    restrict: 'C',
    link: function(scope, element, attrs) {
      // watch for xhr progress

      function turnOnProgressFilter() {
        $rootScope.originatingXhrScope = scope;
      }

      angular.element(element).on('click', turnOnProgressFilter);

      scope.$on('$destroy', function() {
        angular.element(element).off('click', turnOnProgressFilter);
      });

      scope.$watch('scopeXhrRequestInProgress', function(progress) {
        var disabled = !!progress || !!scope.$eval(attrs.ngDisabled);
        element.prop('disabled', disabled);
        element.toggleClass('in-progress', !!progress);
      });
    }
  };
})
.factory('XhrProgress', function($q, $rootScope) {
  var trackedRequests = {};

  function randomString(length) {
    return Math.round((Math.pow(36, length + 1) - Math.random() * Math.pow(36, length))).toString(36).slice(1); // eslint-disable-line max-len
  }

  function handleTrackedResponse(config) {
    if (!config) return;

    var originatingScope = trackedRequests[config.odRequestId];
    delete trackedRequests[config.odRequestId];

    if (!originatingScope) return;
    originatingScope.scopeXhrRequestInProgress = false;
  }

  return {
    request: function(config) {
      config.odRequestId = randomString(64);
      var originatingScope = $rootScope.originatingXhrScope;
      delete $rootScope.originatingXhrScope;

      if (originatingScope) {
        trackedRequests[config.odRequestId] = originatingScope;
        originatingScope.scopeXhrRequestInProgress = true;
      }

      $rootScope.xhrProgress = ($rootScope.xhrProgress || 0) + 1;
      return config;
    },

    requestError: function(rejection) {
      handleTrackedResponse(rejection.config);
      $rootScope.xhrProgress--;
      return $q.reject(rejection);
    },

    response: function(response) {
      handleTrackedResponse(response.config);
      $rootScope.xhrProgress--;
      return response;
    },

    responseError: function(rejection) {
      handleTrackedResponse(rejection.config);
      $rootScope.xhrProgress--;
      return $q.reject(rejection);
    },
  };
})
.config(function($httpProvider) {
  $httpProvider.interceptors.push('XhrProgress');
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/xhr-progress.js
 **/